import { list_url } from "@project/sharedcomponents/apiURL"
import { getCatchErrorMessage, isblank } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { IMPORT_UNIT_LOCAL_SEARCH, IMPORT_UNIT_SERVICE_FAIL, IMPORT_UNIT_SERVICE_START, IMPORT_UNIT_SERVICE_SUCCESS, LOADING_STATE, SNACKBAR_STATE } from "./types"
import { getAccountSitesetting, getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"

export const local_search_importunit = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: IMPORT_UNIT_LOCAL_SEARCH,
      search_text: search_text,
    })
  }
}
export const fetch_import_unit_data = ({ rowsPerPage, page, order, orderBy, search_text, functions }) => {
  const pagination_size = getAccountSitesetting("pagination_size")
  if (isblank(rowsPerPage)) {
    rowsPerPage = pagination_size
  }

  return (dispatch) => {
    dispatch({ type: IMPORT_UNIT_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: false, sidebarstate: true })

    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "importunit")
    data.append("limit", "All")
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)

    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "importunit" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: data,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          importunitServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
        } else {
          importunitServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
        }
      })
      .catch((error) => {
        postErrorOnException(error)
        importunitServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
        dispatch({ type: LOADING_STATE, state: false, sidebarstate: false })
      })
  }
}

const importunitServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: IMPORT_UNIT_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

const importunitServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: IMPORT_UNIT_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
